<section id="options" class="options-section">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 text-center">
        <h2 class="options-caption" [dir]="languageService.getDir()">
          {{'OPTIONS_SECTION.TITLE' | translate}}
        </h2>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-3 options-column">
        <div class="option-card">
          <div class="d-flex justify-content-center option-icon">
            <span class="option-icon-container">
                <i class="fas fa-user option-icon-img"></i>
            </span>
          </div>
          <div class="option-text text-center">
            <h3 [dir]="languageService.getDir()">{{'OPTIONS_SECTION.USER_TEXT' | translate}}</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-3 options-column">
        <div class="option-card">
          <div class="d-flex justify-content-center option-icon">
              <span class="option-icon-container">
                  <i class="fas fa-book-open option-icon-img"></i>
              </span>
          </div>
          <div class="option-text text-center">
            <h3 [dir]="languageService.getDir()">{{'OPTIONS_SECTION.BOOK_TEXT' | translate}}</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-3 options-column">
        <div class="option-card">
          <div class="d-flex justify-content-center option-icon">
            <span class="option-icon-container">
                <i class="fas fa-user-check option-icon-img"></i>
            </span>
          </div>
          <div class="option-text text-center">
            <h3 [dir]="languageService.getDir()">{{'OPTIONS_SECTION.OPTION_TEXT' | translate}}</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-3 options-column">
        <div class="option-card">
          <div class="d-flex justify-content-center option-icon">
            <span class="option-icon-container">
                <i class="fas fa-chart-line option-icon-img"></i>
            </span>
          </div>
          <div class="option-text text-center">
            <h3 [dir]="languageService.getDir()">{{'OPTIONS_SECTION.CHART_TEXT' | translate}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
